import React from 'react';
import './styles/sub-page-layout.scss';
import { Spin } from 'antd';

const SubPageLayout = ({ title, extra, children, className, loading = false }) => {
  return (
    <Spin spinning={loading} size="large">
      <div className={`sub-page-layout d-flex f-col ${className || ''}`}>
        <div className="sp-header d-flex f-row jc-space-between ai-center">
          <div className="left">
            <h1 className="fw-700">{title}</h1>
          </div>
          <div className="right">{extra}</div>
        </div>
        <div className="sb-content">{children}</div>
      </div>
    </Spin>
  );
};

export default SubPageLayout;
